import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";

import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { FirebaseData } from "../../FirebaseData";

export class PropertyInfoFieldGeneralDataHelper extends DataObjectHelper<FirebaseData> {
  id = () => "propertyInfoField";
  allFields(): DataObjectField<any, FirebaseData>[] {
    return [];
  }
  displayName(): string {
    return t("main.information");
  }
  override displayNamePlural(): string {
    return t("main.information");
  }
  getAllDataTableDatas(documents: FirebaseData[]): DataTableData[] {
    return documents.map((data) => {
      return {
        key: data.id,
        cells: {},
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "fields.address.value",
        title: t("main.address"),
      },
      {
        key: "fields.city.value",
        title: t("main.city"),
      },
      {
        key: "fields.floors.value",
        title: t("main.floors"),
      },
      {
        key: "fields.gnr.value",
        title: t("main.gnr"),
      },
      {
        key: "fields.bnr.value",
        title: t("main.bnr"),
      },
      {
        key: "fields.snr.value",
        title: t("main.snr"),
      },
      {
        key: "fields.plotArea.value",
        title: t("main.plotArea"),
      },
      {
        key: "fields.totalArea.value",
        title: t("main.totalArea"),
      },
      {
        key: "fields.totalParkingSpots.value",
        title: t("main.totalParkingSpots"),
      },
    ];
  }
}

